import { style } from "@vanilla-extract/css";
import { primitiveTokens, semanticThemeTokens } from "../theme/ThemeTokens.css";

/**
 * No error: the wrapper must not exist for *layout* (consumers size the
 * control themselves) but must exist in the *DOM*. Swapping a fragment for a
 * div changes the element type at that position, so React remounts the input
 * — dropping focus mid-typing, which truncates any value that passes through
 * an invalid prefix on its way to a valid one.
 */
export const unwrapped = style({
  display: "contents"
});

export const fieldWrapper = style({
  display: "flex",
  flexDirection: "column",
  width: "100%"
});

// In normal flow (not absolutely positioned): a message that wraps to several
// lines must push the content below it down, not overlay it.
export const helperText = style({
  color: semanticThemeTokens.input.invalid.borderColor,
  fontSize: primitiveTokens.type.xs,
  minHeight: primitiveTokens.sizing["4x"],
  padding: `${primitiveTokens.sizing["1x"]} ${primitiveTokens.sizing["0x"]}`
});
